import React from 'react';
import { Mail, Phone, MapPin, Youtube, Facebook, Instagram, MessageCircle, ArrowUp } from 'lucide-react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.brandCol}>
            <div className={styles.logo}>
              <span className={styles.logoText}>ANANTA</span>
              <div className={styles.logoDot} />
            </div>
            <p className={styles.description}>
              Empowering the next generation of digital newsrooms with hyper-realistic AI Anchors.
            </p>
            <div className={styles.socials}>
              <a href="#" className={styles.socialIcon}><Youtube size={20} /></a>
              <a href="#" className={styles.socialIcon}><Facebook size={20} /></a>
              <a href="#" className={styles.socialIcon}><MessageCircle size={20} /></a>
            </div>
          </div>

          <div className={styles.linksCol}>
            <h4 className={styles.colTitle}>Quick Links</h4>
            <ul className={styles.list}>
              <li><a href="#about">Technology</a></li>
              <li><a href="#samples">Video Samples</a></li>
              <li><a href="#pricing">Pricing Plans</a></li>
              <li><a href="#services">Our Services</a></li>
            </ul>
          </div>

          <div className={styles.contactCol}>
            <h4 className={styles.colTitle}>Contact</h4>
            <ul className={styles.list}>
              <li><Phone size={18} color="#e87355" /> +91 7533928185</li>
              <li><Mail size={18} color="#e87355" /> info@anantainfotech.com</li>
              <li><MapPin size={18} color="#e87355" /> Dineshpur , Rudrapur , udham singh nagar , uttarakhand </li>
            </ul>
          </div>
        </div>

        <div className={styles.bottomBar}>
          <p>© 2026 Ananta Infotech. All rights reserved.</p>
          <p1>Designed by Ananta Team</p1>
          <button className={styles.scrollTop} onClick={() => window.scrollTo({top:0, behavior:'smooth'})}>
            <ArrowUp size={20} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;